import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { FormBlock } from '@/components/FormBlock';
import { useZustandSync } from '@/hooks/useZustandSync';
import { productStore } from '@/stores/productStore';

import { ErrorMessage } from '../form/ErrorMessage';
import PhoneInput from '../form/PhoneInput';
import { HelpText } from '../ui/HelpText';

const producerCellPhoneSchema = z.object({
  producerCellPhone: z.string().min(13, 'Preencha o número de celular').nonempty('O número de celular é obrigatório')
});

type ProducerCellPhoneFormValues = z.infer<typeof producerCellPhoneSchema>;

export default function ProducerCellPhone() {
  const form = useForm<ProducerCellPhoneFormValues>({
    resolver: zodResolver(producerCellPhoneSchema),
    mode: 'onChange',
    defaultValues: { producerCellPhone: productStore.getState().producer.cellPhone || '' }
  });

  useZustandSync<ProducerCellPhoneFormValues>(form.control, (data, current) => ({
    producer: {
      ...(current.producer || {}),
      cellPhone: data.producerCellPhone
    }
  }));

  return (
    <FormBlock name='producer-phone' form={form} title='Celular' allowOverflow>
      <PhoneInput inputName='producerCellPhone' defaultConfig={{ defaultCountry: 'br' }} />
      <ErrorMessage fieldName='producerCellPhone' />

      <HelpText>
        Prometemos não enviar spams. Você receberá apenas avisos relevantes sobre seu produto e suas vendas.
      </HelpText>
    </FormBlock>
  );
}
